import { type CreateBlockData } from '@/lib/builder/types'

import {
  type GetTheAppButtonsSection,
  type GetTheAppButtonsSectionCreate,
} from '../../../types'

export const createGetTheAppButtonsData = (
  _createBlockData: CreateBlockData<GetTheAppButtonsSection>
): GetTheAppButtonsSectionCreate => ({
  data: null,
  type: 'get-the-app-buttons',
})
